/* eslint-disable no-console */
import {Flex} from 'antd';
import React from 'react';

import {ReactComponent as CopilotBigIcon} from '../../assets/copilotBigIcon.svg';

const IntroText: React.FC<{
  setClickToTextArea: React.Dispatch<any>;
  textRef: React.MutableRefObject<any>;
}> = ({setClickToTextArea, textRef}) => {
  const clickButtonArray = [
    {value: 'Sustainable sourcing'},
    {value: 'Accessibility of workplaces'},
    {value: 'Health and safety management system'}
  ];

  return (
    <Flex align="center" justify="center" vertical gap={15}>
      <div className="icon-circle">
        <CopilotBigIcon />
      </div>
      <Flex className="welcomeNetZero">Welcome to Net Zero Copilot</Flex>
      <Flex className="whatCanDo">Here’s what you can do:</Flex>
      <Flex
        gap={10}
        style={{
          flexWrap: 'wrap',
          justifyContent: 'center',
          margin: '0px 16px'
        }}
      >
        {clickButtonArray?.map((item, index) => {
          return (
            <div
              className="pilDiv"
              onClick={() => {
                setClickToTextArea({...item, type: 'send'});
                textRef.current.focus();
              }}
              key={index}
            >
              {item?.value}
            </div>
          );
        })}
      </Flex>
    </Flex>
  );
};

export default IntroText;
